import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Input as AntInput} from 'antd';
import {toClass} from 'recompose';
import styles from './index.less';

const getClassNames = ({size, className}) => classNames(
    styles[`size-${size}`],
    className
);

const etuiSizeToAntd = {s: 'small', m: 'default', l: 'large', xl: 'large'};

const ETUIInput = props => {
    const {size, className, ...restProps} = props;

    return (
        <AntInput
            size={etuiSizeToAntd[size]}
            className={getClassNames({size, className})}
            {...restProps}
        />
    );
};

const ETUIInputClsComponent = toClass(ETUIInput);

Object.assign(ETUIInputClsComponent, AntInput);

ETUIInputClsComponent.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl'])
};

ETUIInputClsComponent.defaultProps = {
    className: '',
    size: 'm'
};

export default ETUIInputClsComponent;
